import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { types } from '@/modules/servis/doklad/store/types';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		DokladDruh: [],
		CenotvorbandPzn: [],
		EetCommunicStatusPzn: [],
		NoraPzn: [],
		PlatbaPzn: [],
		SlevamatSk: [],
		VyrobekvozOzn: [],
		ZakazkaDruh: [],
		ZakaznikSk: [],
		EetCommunicStatusPznList: [],
	},
	filter: {
		PrijemceDicNr: null as string | null,
		DokladDruh: null as string | null,
		ZakazkaDruh: null as string | null,
		DokladPfx: null as string | null,
		DokladNr: null as number | null,
		DuzpDatOd: null as Date | null,
		DuzpDatDo: null as Date | null,
		PrijemceIcoNr: null as string | null,
		PrijemcePrijmeniFirma: null as string | null,
		PlatbaPzn: null as number | null,
		SplatnostDatOd: null as Date | null,
		SplatnostDatDo: null as Date | null,
		PartialInvoiceDateOd: null as Date | null,  //added
		PartialInvoiceDateDo: null as Date | null,    //added
		ProvozovnaId: null as number | null,
		Spz: null as string | null,
		Terminal: null as string | null,
		UzavreniDatOd: null as Date | null,
		UzavreniDatDo: null as Date | null,
		PartialBillingClosedDate: null as Date | null,
		VyrobekvozOzn: null as string | null,
		VozidloId: null as number | null,
		VozidloText: null as string | null,
		ZakazkaNr: null as number | null,
		ZakaznikId: null as number | null,
		ZakaznikIdText: null as string | null,
		IntrDruhOzn: null as number | null,
		PovId: null as number | null,
		PnvId: null as number | null,
		PujcovnapaId: null as number | null,
		ZakaznikSk: null as number | null,
		CenotvorbandPzn: null as number | null,
		NoraPzn: null as number | null,
		SlevamatSk: null as number | null,
		EetCommunicStatusPznList: [] as number[],
		VozidloVin: null as string | null,
	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[types.mutations.DOKLAD_ZAKAZNIK_SELECT_MAPPER](state, { data }) {
			state.filter.ZakaznikId = data.value;
			state.filter.ZakaznikIdText = data.text;
		},
		[types.mutations.DOKLAD_VOZIDLO_SELECT_MAPPER](state, { data }) {
			state.filter.VozidloId = data.value;
			state.filter.VozidloText = data.text;
			state.filter.Spz = data.spz;
			state.filter.VozidloVin = data.karoserieNr;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
